import { Vote } from '@vote4dance/judging-schema';
import { RoundId } from '@vote4dance/judging-types';
import { StreamSource } from "../hooks/streams";

export function RoundVotesSource(round_id: RoundId) {
    return new StreamSource<Vote[]>(`/votes/${round_id}`);
}